import { IWykrojnikParams } from "@/../../src/wykrojniki/params/IWykrojnikParams"
import { ITree } from "@/../../src/tree/ITree"
import { ILbl } from "@/../../src/lbl/ILbl"
import { IWykrojnik } from "@/../../src/wykrojniki/IWykrojnik";


export interface IDimensions {
    from: string
    x:number,
    y:number
}

export class Dims {
    private static isNumber(value: string): boolean {
        return !isNaN(parseFloat(value)) && isFinite(Number(value));
    }

    private static asNumber(v: any): number {
        if (!v) return 0.0;
        const value = v.toString()
        const parsed = parseFloat(value);
        if (isNaN(parsed)) {
        return 0.0;
        }
        return parseFloat(parsed.toFixed(1));
    }

    private static get_dims(lbl:ILbl|undefined, tree: ITree|undefined, wykrojnik:IWykrojnik|undefined, wp: IWykrojnikParams|undefined ): IDimensions|undefined {
        if (lbl && lbl.x && lbl.y)                      return { from:"lbl", x:this.asNumber(lbl.x), y:this.asNumber(lbl.y)}
        if (tree && tree.x && tree.y)                   return { from: "tree",x:this.asNumber(tree.x), y:this.asNumber(tree.y)}
        if (wykrojnik && wykrojnik.x && wykrojnik.y)    return { from:"wykrojnik",x:this.asNumber(wykrojnik.x), y:this.asNumber(wykrojnik.y)}
        if (wp && wp.x && wp.y)                         return { from:"wp", x:this.asNumber(wp.x), y:this.asNumber(wp.y)}
        return undefined
    }


    public static set_dims_to_tree(lbl:ILbl|undefined, tree: ITree|undefined, wykrojnik:IWykrojnik|undefined, wp: IWykrojnikParams|undefined ):string[] {
        const msg:string[]=[]
        if (!tree) return ["set_dims_to_tree: no tree specified"]
        const dims = this.get_dims(lbl, tree, wykrojnik, wp )
        if (!dims) return ["set_dims_to_tree: no dims"];
        if (dims && (!tree.x && !tree.y)) {
            tree.x = dims.x
            tree.y = dims.y
        }
        return msg
    }

    public static set_xy_to_tree(tree:ITree|undefined, x_any: any, y_any:any ):string[] {
        const msg:string[]=[]
        if (!tree) return ["set_xy_to_tree: no tree"]
        const x = this.asNumber(x_any)
        const y = this.asNumber(y_any)

        if (!x) return ["set_dims_to_tree: no x"]
        if (!y) return ["set_dims_to_tree: no y"]

        const dims: IDimensions = {from: "ops", x,y}
        if (dims && (!tree.x && !tree.y)) {
            tree.x = dims.x
            tree.y = dims.y
        }
        return msg
    }

    public static set_dims_to_lbl(lbl:ILbl|undefined, x_any: any, y_any:any ):string[] {
        const msg:string[]=[]
        if (!lbl) return ["set_dims_to_lbl: no lbl"]
        const x = this.asNumber(x_any)
        const y = this.asNumber(y_any)

        if (!x) return ["set_dims_to_lbl: no x"]
        if (!y) return ["set_dims_to_lbl: no y"]

        const dims: IDimensions = {from: "cloudflow", x,y}
        if (dims && (!lbl.x && !lbl.y)) {
            lbl.x = dims.x
            lbl.y = dims.y
        }
        return msg
    }

    public static set_dims_to_wp(lbl:ILbl|undefined, tree: ITree|undefined, wykrojnik:IWykrojnik|undefined, wp: IWykrojnikParams|undefined ):string[] {
        const msg:string[]=[]
        if (!wp) return ["set_dims_to_wp: no wp"]
        const dims = this.get_dims(lbl, tree, wykrojnik, wp )
        if (!dims) return ["set_dims_to_wp: no dims"];
        if (dims && (wp.x != dims.x || wp.y!=dims.y)) {
            wp.x = dims.x
            wp.y = dims.y
        }
        return msg
    }


}
